import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
import Navbar from './Navbar';
import useUISettings from '../../hooks/useUISettings';

function Header() {
  const { isAuthenticated, user } = useAuthStore();
  const { siteName, logoUrl } = useUISettings();

  return (
    <header className="bg-gray-900/95 backdrop-blur-sm border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 rounded-lg gradient-bg flex items-center justify-center">
              {logoUrl ? (
                <img src={logoUrl} alt={siteName} className="w-10 h-10 rounded-lg object-cover" />
              ) : (
                <span className="text-white font-bold text-xl">{siteName?.[0] || 'V'}</span>
              )}
            </div>
            <span className="text-xl font-bold gradient-text">{siteName}</span>
          </Link>

          {/* Navigation */}
          <Navbar />

          {/* Auth buttons / User menu */}
          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <div className="flex items-center space-x-4">
                <Link
                  to="/voice-cloning"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Voice Cloning
                </Link>
                <Link
                  to="/profile"
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors"
                >
                  <div className="w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center">
                    <span className="text-sm font-medium">
                      {user?.full_name?.[0] || user?.email?.[0] || 'U'}
                    </span>
                  </div>
                </Link>
              </div>
            ) : (
              <div className="flex items-center space-x-3">
                <Link
                  to="/login"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Login
                </Link>
                <Link to="/signup" className="btn btn-primary text-sm py-2">
                  Get Started
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
